/**
 * 애플리케이션 라우팅 설정
 */

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ROUTES } from '../shared/constants/routes';
import { ScrollToTop } from '../shared/components';
import { HomePage } from '../features/home';
import { AboutChurch, Greeting, WorshipGuide, Location } from '../features/church-intro';
import {
  SundayMorningSermon,
  SundayEveningSermon,
  WednesdaySermon,
  DawnSermon,
  FridaySermon,
  SermonDetail,
} from '../features/sermon';
import {
  SundaySchoolIntro,
  SundaySchoolBoard,
  SundaySchoolBoardDetail,
} from '../features/sunday-school';
import {
  HallelujahChoir,
  WiryeChoir,
  PraiseTeam,
  Agape,
} from '../features/department';
// import { NewFamilyForm } from '../features/new-family';
import {
  NewsBoard,
  NewsBoardDetail,
  Gallery,
  GalleryDetail,
  Bulletin,
  BulletinDetail,
} from '../features/community';
import {
  Login,
  AdminLayout,
  Dashboard,
  SliderManager,
  BoardManager,
  BoardForm,
  // NewFamilyManager,
} from '../features/admin';
import { AuthProvider } from '../features/admin/contexts/AuthContext';
import { ApiTest } from '../features/test/ApiTest';

const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <Routes>
          {/* API 테스트 페이지 */}
          <Route path="/api-test" element={<ApiTest />} />

          <Route path={ROUTES.HOME} element={<HomePage />} />

          {/* 교회 소개 */}
          <Route path={ROUTES.CHURCH_INTRO.ABOUT} element={<AboutChurch />} />
          <Route path={ROUTES.CHURCH_INTRO.GREETING} element={<Greeting />} />
          <Route path={ROUTES.CHURCH_INTRO.WORSHIP} element={<WorshipGuide />} />
          <Route path={ROUTES.CHURCH_INTRO.LOCATION} element={<Location />} />

          {/* 설교 영상 */}
          <Route path={ROUTES.SERMON.SUNDAY_MORNING} element={<SundayMorningSermon />} />
          <Route path={ROUTES.SERMON.SUNDAY_EVENING} element={<SundayEveningSermon />} />
          <Route path={ROUTES.SERMON.WEDNESDAY} element={<WednesdaySermon />} />
          <Route path={ROUTES.SERMON.DAWN} element={<DawnSermon />} />
          <Route path={ROUTES.SERMON.FRIDAY} element={<FridaySermon />} />
          <Route path="/sermon/:sermonType/:id" element={<SermonDetail />} />

          {/* 교회학교 */}
          <Route path={ROUTES.SUNDAY_SCHOOL.INTRO} element={<SundaySchoolIntro />} />
          <Route path={ROUTES.SUNDAY_SCHOOL.BOARD} element={<SundaySchoolBoard />} />
          <Route path="/sunday-school/board/:id" element={<SundaySchoolBoardDetail />} />

          {/* 부서 안내 */}
          <Route path={ROUTES.DEPARTMENT.HALLELUJAH_CHOIR} element={<HallelujahChoir />} />
          <Route path={ROUTES.DEPARTMENT.WIRYE_CHOIR} element={<WiryeChoir />} />
          <Route path={ROUTES.DEPARTMENT.PRAISE_TEAM} element={<PraiseTeam />} />
          <Route path={ROUTES.DEPARTMENT.AGAPE} element={<Agape />} />

          {/* 새가족 */}
          {/* <Route path={ROUTES.NEW_FAMILY} element={<NewFamilyForm />} /> */}

          {/* 커뮤니티 */}
          <Route path={ROUTES.COMMUNITY.NEWS} element={<NewsBoard />} />
          <Route path="/community/news/:id" element={<NewsBoardDetail />} />
          <Route path={ROUTES.COMMUNITY.GALLERY} element={<Gallery />} />
          <Route path="/community/gallery/:id" element={<GalleryDetail />} />
          <Route path={ROUTES.COMMUNITY.BULLETIN} element={<Bulletin />} />
          <Route path="/community/bulletin/:id" element={<BulletinDetail />} />

          {/* 관리자 */}
          <Route path={ROUTES.ADMIN.LOGIN} element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<Dashboard />} />
            {/* <Route path="dashboard/new-family" element={<NewFamilyManager />} /> */}

            {/* 메인 슬라이더 - 정적 이미지로 변경되어 비활성화 */}
            {/* <Route path="slider" element={<SliderManager />} /> */}

            {/* 게시판별 라우트 */}
            <Route path="board/sunday-school" element={<BoardManager boardType="sunday-school" boardLabel="교회학교" />} />
            <Route path="board/news" element={<BoardManager boardType="news" boardLabel="교회소식" />} />
            <Route path="board/gallery" element={<BoardManager boardType="gallery" boardLabel="갤러리" />} />
            <Route path="board/bulletin" element={<BoardManager boardType="bulletin" boardLabel="주보" />} />

            {/* 게시판 작성/수정 */}
            <Route path="board/:boardType/new" element={<BoardForm />} />
            <Route path="board/:boardType/:id/edit" element={<BoardForm />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRoutes;
